<template>
  <article class="media post">
    <figure
      v-if="post.data.thumbnail && post.data.thumbnail.startsWith('http')"
      class="media-left"
    >
      <div class="post-image image">
        <img :src="post.data.thumbnail" />
      </div>
    </figure>
    <div class="media-content">
      <div class="flex justify-between items-start mb2">
        <div>
          <div class="flex top">
            <small class="mr2">
              <a
                :href="
                  `https://reddit.com/${post.data.subreddit_name_prefixed}`
                "
                target="_blank"
                >{{ post.data.subreddit_name_prefixed }}</a
              >
            </small>
            <small>
              <a
                :href="`https://reddit.com/u/${post.data.author}`"
                target="_blank"
                >u/{{ post.data.author }}</a
              >
            </small>
          </div>
          <h4 class="b f4 has-text-white">
            <a
              :href="`https://reddit.com/${post.data.permalink}`"
              target="_blank"
              >{{ post.data.title }}</a
            >
          </h4>
        </div>

        <b-button
          class="ml3"
          @click="$emit('save', { post })"
          type="is-primary"
          size="is-small"
          >Save post</b-button
        >
      </div>

      <p class="text" v-if="!$utils.isEmpty(post.data.selftext)">
        {{ post.data.selftext | truncate(200) }}
      </p>
      <p class="text hyphenate" v-else-if="!$utils.isEmpty(post.data.body)">
        {{ post.data.body | truncate(200) }}
      </p>

      <div v-if="post.data.url">
        <h5 class="b f5 mt3 mb2">Media URL:</h5>
        <div class="flex justify-start items-center url">
          <span class="url-link" @click="openURLPreview(post.data.url)">{{
            post.data.url
          }}</span>
          <!-- <a class="url-link" :href="post.data.url" target="_blank">{{ post.data.url }}</a>
          <b-button
            size="is-small"
            class="url-save-button ml3"
            outlined
            @click="$emit('save', { post, url: post.data.url })"
          >Save URL</b-button>-->
        </div>
      </div>

      <div v-if="post._urls.length > 0">
        <h5 class="b f5 mt3 mb2">Extracted URLs:</h5>
        <div
          v-for="(url, index) in post._urls"
          :key="index"
          class="flex justify-start items-center url mb2"
          @click="openURLPreview(url)"
        >
          <span class="url-link">{{ url }}</span>
          <!-- <a class="url-link" :href="url" target="_blank">{{ url }}</a>
          <b-button
            size="is-small"
            class="url-save-button ml3"
            outlined
            @click="$emit('save', { post: null, url })"
          >Save URL</b-button>-->
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    post: {
      type: Object
    }
  },

  methods: {
    openURLPreview(url) {
      this.$buefy.dialog.confirm({
        message: url,
        cancelText: "Open URL",
        confirmText: "Save URL",
        animation: "pop-modal",
        onConfirm: () => {
          this.$emit("save", { url });
        },
        onCancel: () => {
          window.open(url, "_blank");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.post-image {
  width: 128px;
  height: auto;
}

.post {
  color: $text;

  a {
    color: inherit;
  }

  .media-content {
    min-width: 0;
  }
}

.top {
  color: $light_40;
}
.text {
  opacity: 0.85;
}
.url {
  &-link {
    // width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    padding: 3px 6px;
    background: $light_05;
    border-radius: 3px;
    cursor: pointer;
  }

  &-save-button {
    opacity: 0;
    visibility: hidden;
  }

  &:hover {
    .url-save-button {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
